<template>
  <div id="channelWrapper">
    <!-- 搜索栏 -->
    <div class="search-box">
      <div></div>
      <div>
        <Button v-if="hasPerm('access_channel_add_btn') == 2" class="ys-confirm" icon="ios-add"
          @click="handleAddClick">新建</Button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table :columns="Columns" :tableData="tableData" :loading="tableLoading" :tableHeight="tableHeight"
      @on-btn-click="onBtnClick">
    </el-table>
    <!-- 分页 -->
    <div class="paging-box">
      <Page :page-size="12" :total="totalCount" :current="page" @on-change="handlePagingClick" />
    </div>
    <!-- 新建、编辑的弹框 -->
    <add-channel v-if="channelStatus" :titleLayer="titleLayer" :channelValue="channelValue" :editDetail="editDetail"
      @on-channel-click="onChannelClick"></add-channel>
    <!-- 删除提示 -->
    <div>
      <Alter ref="alterModal" :configData="configData" @change_ok="deleteChannelActions"></Alter>
    </div>
  </div>
</template>
<script>
  import {
    mapActions
  } from "vuex";
  import elementResizeDetectorMaker from "element-resize-detector"; // 获取元素的高度
  import ElTable from '_g/commonComponent/table/elTable.vue';
  import AddChannelModel from '../component/AddChannelModel.vue'; // 新建弹框
  export default {
    components: {
      'el-table': ElTable,
      'add-channel': AddChannelModel
    },
    data() {
      return {
        tableData: [], // 数据
        Columns: [{
            title: '渠道编号',
            key: 'channel_code',
            width: 150,
            render: (
              h, {
                columns,
                row,
                index
              }) => {
              return h("span", {
                  style: {
                    textDecoration: 'underline',
                    color: '#3485FB'
                  },
                  on: {
                    click: () => {
                      this.editDetail = row;
                      this.processing(3);
                    }
                  }
                },
                row.channel_code)
            }
          },
          {
            title: '渠道名称',
            key: 'channel_cn_name',
            width: 300,
          },
          {
            title: '渠道类型',
            key: 'channel_type',
            width: 300,
            render: (h, {
              columns,
              row,
              index
            }) => {
              let target_host = '';
              switch (row.channel_type) {
                case 1:
                  target_host = 'PC web接入';
                  break;
                case 2:
                  target_host = 'Andriod APP接入';
                  break;
                case 3:
                  target_host = 'IOS APP接入';
                  break;
                case 4:
                  target_host = 'IPad APP 接入';
                  break;
                case 5:
                  target_host = 'Email';
                  break;
                case 6:
                  target_host = '微信';
                  break;
                default:
                  target_host = '--'
              }
              return h("span", target_host);
            }
          },
          {
            title: '渠道描述',
            key: 'channel_bk_desc',
          },
          {
            title: '操作',
            slot: 'iconfont',
            width: 150,
            iconClass: [{
                name: "ys-iconbianji",
                code: "编辑",
                status: 1,
                Pname: 'access_channel_tab_edit'
              },
              {
                name: "ys-iconlajitongbeifen",
                code: "删除",
                status: 1,
                Pname: 'access_channel_tab_delate'
              },
            ]
          },
        ], // 表头
        totalCount: 0, // 总条数
        page: 1,
        tableHeight: 0,
        searchValue: '', // 搜索框的值

        // 弹框信息
        titleLayer: 1,
        channelStatus: false,
        channelValue: false,
        editDetail: '',
        configData: {}, // 弹框配置信息
        tableLoading: true, // 表格loading
      }
    },
    methods: {
      ...mapActions([
        'channleList', // 列表
        'deleteChannelAction', // 删除
      ]),
      // 获取元素的高度
      getElementHeight() {
        let ERD = elementResizeDetectorMaker();
        let _this = this;
        ERD.listenTo(document.getElementById("channelWrapper"), (element) => {
          _this.tableHeight = (element.offsetHeight - 66 - 60 - 20); // 在该基础上多-20跟分页有间距
        });
      },
      // 操作按钮
      onBtnClick(rowItem, options) {
        switch (options.code) {
          case '编辑':
            this.editDetail = rowItem;
            this.processing(2);
            break;
          case '删除':
            this.editDetail = rowItem;
            this.DeleteComponent();
            break;
        }
      },
      // 删除
      DeleteComponent() {
        this.configData = {
          type: "warning",
          title: "警告",
          content: "是否删除当前信息"
        };
        this.$refs.alterModal.OpenModal();
      },
      // 新建功能
      handleAddClick() {
        this.titleLayer = "新建";
        this.processing(1);
      },
      // 新建跟编辑封装
      processing(code) {
        this.channelValue = true;
        this.channelStatus = true;
        this.titleLayer = code === 1 ? 1 : code === 2 ? 2 : 3;
      },
      // 弹框回调
      onChannelClick() {
        this.channelValue = false;
        this.channelStatus = false;
        // 刷新列表
        this.page = 1;
        this.channleLists();
      },
      // 分页功能
      handlePagingClick(res) {
        this.page = res;
        // 获取列表
        this.channleLists();
      },
      // 渠道列表
      async channleLists() {
        try {
          this.tableLoading = true;
          let ev = {
            start_recd: (this.page - 1) * 12,
            limit_recd: 12,
          }
          const data = await this.channleList(ev);
          if (data.request_state) {
            this.totalCount = data.all_recd;
            this.tableData = data.channel_list;
            this.tableLoading = false;
          }
        } catch (error) {
          console.log(error);
          this.tableLoading = false;
        }
      },
      // 删除
      async deleteChannelActions() {
        try {
          const data = await this.deleteChannelAction({
            channel_code: this.editDetail.channel_code
          });
          if (data.request_state) {
            this.$Message.success('删除成功~~');
            // 刷新页面
            this.page = 1;
            this.channleLists();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    mounted() {
      // 获取元素高度
      this.getElementHeight();
      // 获取列表
      this.channleLists();
    }
  }
</script>
<style lang="less" scoped>
  #channelWrapper {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 50px;
    box-sizing: border-box;

    .search-box {
      width: 100%;
      height: 66px;
      padding: 22px 0px 12px 0px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
    }

    .paging-box {
      position: fixed;
      bottom: 0px;
      right: 50px;
      z-index: 1;
      height: 60px;
      width: calc(100% - 250);
      text-align: right;
    }
  }
</style>